// extracted by mini-css-extract-plugin
export default {"root":"styles_root__sfvLq","close_link":"styles_close_link__CsKKe","main":"styles_main__ltv-8"};